import ReactPlayer from "react-player";

function HistoryDetail() {
  return (
    <div className="nunito-300 text-[14px]  min-h-[400px]">
      {/* <img src="/new/cover.jpg" alt="" className="mb-2" /> */}
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0002.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0003.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0004.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0005.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0006.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0007.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0008.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0009.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0010.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0011.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0012.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0013.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0014.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0015.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0016.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0017.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0018.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0019.jpg"
        alt=""
        className="mb-2"
      />
      <img
        src="desc/Instal Naran Construction_Taniltsuulga_Ekh_LAST_Har_LAST_page-0020.jpg"
        alt=""
        className="mb-2"
      />

      <div className="nunito-300 text-[14px] my-2 md:my-5 text-justify">
        Манай компани нь анх 2009 онд байгуулагдаж өнөөг хүртэл МУын барилгын
        салбарт үйл ажилгаагаа амжилттай явуулж байна. <br />
      </div>
      <div className="nunito-300 text-[14px] my-2 text-justify">
        Бид 2014 онд компаниа өргөжүүлж “Инсталл наран констракшн” ХХК болгон
        БУА-ын 2.1.1~5, 2.2.1~4 болон БА-6.2 тус тус заалттай тусгай
        зөвшөөрөлтэйгээр үйл ажиллагаагаа явуулж байна <br />
      </div>
      {/* <img src="/new/staffs.png" alt="" className="my-3" /> */}

      <div className="nunito-300 text-[14px] mb-2 text-justify">
        Мөн 2022 онд “Инсталл наран конкрит” ХХК МҮ-4.2.3 тусгай зөвшөөрөлтэй
        бетон зуурмагийн үйлдвэрээ байгуулж чанарын өндөр түвшинд,
        үйлчлүүлэгчийн хэрэгцээ шаардлагад нийцсэн бетон зуурмагийг нийлүүлэн
        ажиллаж байна. <br />
      </div>
      <ReactPlayer width={"100%"} url="https://fb.watch/khvhdcoiHZ/" />
    </div>
  );
}

export default HistoryDetail;
